// extracted by mini-css-extract-plugin
module.exports = {"row":"GoogleAppRow__row","displayFlex":"GoogleAppRow__displayFlex","img":"GoogleAppRow__img","centerAlign":"GoogleAppRow__centerAlign"};